import _ from 'lodash'
import LoadingBtn from '../../../common/ui/loading_btn.vue'


export default {
	name: 'DrawingModes',
	data() {
		return {
			
		}
	},
	props: [],
	watch: {
		
	},
	created(){
		
	},
	mounted(){
	},
	methods: {
		activateDrawingMode(mode) {
			if(this.$store.state.annotations.drawingMode !== mode){
				this.$store.dispatch('setAnnotationsDrawingMode', mode)
			}else{
				this.$store.dispatch('setAnnotationsDrawingMode', null)
			}
		},
		deleteAllAnnotationsElements() {
			this.$store.dispatch('deleteAllAnnotationsElements')
		}
	},
	computed:{
		
	},
	components:{
		LoadingBtn
	}
}